angular.module('picmonic-common').factory('WordPressResource', [
  '$resource',
  function ($resource) {
    return $resource(
      'https://www.picmonic.com/pages/wp-json/wp/v2/:resource/:resource_id/?p=icmonic',
      { resource: '@resource', resource_id: '@resource_id', slug: '@slug' },
      {
        get: {
          method: 'GET',
          isArray: true,
          headers: {
            'X-Requested-With': undefined,
            'If-Modified-Since': undefined,
          },
        },
      }
    );
  },
]);
